import { render, staticRenderFns } from "./customerInfoEdit.vue?vue&type=template&id=53e03a64&scoped=true"
import script from "./customerInfoEdit.vue?vue&type=script&lang=js"
export * from "./customerInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./customerInfoEdit.vue?vue&type=style&index=0&id=53e03a64&prod&lang=scss"
import style1 from "./customerInfoEdit.vue?vue&type=style&index=1&id=53e03a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e03a64",
  null
  
)

export default component.exports